import { useEffect } from "react";
import { pushEvent } from "../../../utils";
import { GA_EVENTS } from "../../../utils/constants";

/**
 * @desc Manage convention view.
 */
export const useConventionView = ({ cname }) => {
  /**
   * @desc Only once, trigger view event.
   */
  useEffect(() => {
    if (cname) {
      setTimeout(() => {
        pushEvent("view", {
          event_category: GA_EVENTS.PAGE_VIEW,
          convention: cname,
          date: new Date().toISOString(),
        });
      }, 1000);
    }
  }, [cname]);
};
